import ValidService from "../../../service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
    nguoi_check_in_id: null, //IdRef, optional // Mã người đến checkin
    diem_den_an_toan_id: null, //IdRef, optional // Mã điểm đến
    thoi_diem_check_in: null, //datetime, optional // Thời điểm check in
    nguoi_tao_id: null, //IdRef, optional // Mã người tạo

};

// validation form
model.validForm = {

    nguoi_check_in_id: [ValidService.required], //IdRef, optional // Mã người đến checkin
    diem_den_an_toan_id: [ValidService.required], //IdRef, optional // Mã điểm đến
    thoi_diem_check_in: [], //datetime, optional // Thời điểm check in
    nguoi_tao_id: [], //IdRef, optional // Mã người tạo
};

// dữ liệu mẫu các form khác
model.dataFormOther = {
    check_in: {
        so_the: null,
    }
};

// validation các form khác
model.validFormOther = {
    check_in: {
    cardCode: [ValidService.required],
    }
};

model.tableRules = {
    data: [],
    lengthMenu: [10, 20, 50, 100, 500],
    allowPaging: true,
    allowSorting: true,
    allowSelect: false,
    showFormSearch: false,
    showUrl: true,
    total: 0,
    page: 1,
    limit: 10,
    offset: 0,
    sort: "",
    defaultSort: ["thoi_diem_check_in", "descending"],
    filters: "",
    recordSelected: [],
    dataSearch: {
        value: {
            ten_nguoi_check_in: '',
            ten_diem_den_an_toan: '',
            nguoi_check_in_id: '',
            diem_den_an_toan_id: '',
            thoi_diem_check_in: '',
            doi_tuong_thuc_hien:''

        },
        valid: {
            ten_nguoi_check_in: [],
            ten_diem_den_an_toan: [],
            nguoi_check_in_id: [],
            diem_den_an_toan_id: [],
            thoi_diem_check_in: [],
            doi_tuong_thuc_hien:[]

        },
        operator: {
            ten_nguoi_check_in: ":regex_i:", //:regex:, $vn_text=Viêt nam
            ten_diem_den_an_toan: ":regex_i:",
            thoi_diem_check_in: ':in_that_day:',
            doi_tuong_thuc_hien:''
        }
    }
};

export default model;
